<div class="cq-header">
  <div class="logo">
    <div class="logo-img">
      <img src="/assets/images/COV_BM_P_std_FC_neg_RGB.png" alt="covestro-logo" />
    </div>
    <div class="site-name">CQ-Configurator</div>
  </div>

  <div class="site-slogan">
    @if (isLogin) {
      <div class="site-guide" (click)="openDictionary()">
        <img src="/assets/icons/book-logo.png" alt="site-guidance" />
        Glossary
      </div>
    }
  </div>

  <div
    [hidden]="isLogin ? !isDictionDisplayed : false"
    [@slideInOut]="isLogin ? (isDictionDisplayed ? 'in' : 'out') : 'out'"
    [ngClass]="{ dictionary: true, open: isDictionDisplayed }"
  >
    <cq-dictionary (closeDictionaryEmitter)="openDictionary()"></cq-dictionary>
  </div>
</div>
